import React from "react";
import { Text } from "basis";
import {
  MONTHLY_FEES,
  FEES,
  RATES,
} from "../../../../components/Promotions/Description/constants";
import { currencyFormat } from "../../../../utils";
import { LessThanMinAmount } from "./LessThanMinAmount";
import {
  LOCATION,
  WIDGET_DEFAULT_MINIMUM_AMOUNT_CENTS,
} from "../../../../../assets/constants";

export const Minimum = ({ au, nz, order }) => {
  if (
    order?.location === LOCATION.WIDGET &&
    order?.price < WIDGET_DEFAULT_MINIMUM_AMOUNT_CENTS
  ) {
    return <LessThanMinAmount au={au} nz={nz} />;
  }

  const AU = () => (
    <>
      <Text align="center" margin="3 0">
        Approved customers only using a Minimum Monthly
        Payment Plan. Paying only the minimum monthly payments
        will not pay out the plan. After the interest free plan ends
        interest will be charged on any outstanding balance at the
        expired plan rate, currently {RATES["GEM_VISA_AU"]}% p.a. (subject to change).
      </Text>
      <Text align="center" margin="3 0">
        New customers must apply &amp; be approved for a <strong>Latitude {order?.checkoutTemplate === 'HN' ? 'GO Mastercard credit card' : 'Gem Visa credit card'}</strong>.
      </Text>
    </>
  );

  const NZ = () => (
    <>
      <Text textStyle="body2" margin="0 0 3" align="center">
        Lending criteria, T&C's and fees apply including a ${FEES["ESTABLISHMENT"]} establishment fee and ${FEES["GEM_VISA"]} annual fee (${FEES["GEM_VISA_HALF_YEARLY"]} half yearly). Standard interest rate (currently {RATES["GEM_VISA_NZ"]}% p.a.) applies after interest free term ends.
        Credit provided by Latitude Financial Services Limited.
      </Text>
    </>
  );

  return (
    <>
      {au && <AU />}
      {nz && <NZ />}
    </>
  );
};